import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import * as UserActions from '../../login/state/user.actions';
import { selectCustomerPermissions } from '../../login/state/user.selectors';

@Injectable()
export class CanAdminCustomerGuard {
  constructor(private store: Store) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectCustomerPermissions).pipe(
      map((permissions: string[]) => {
        if (!permissions || !permissions.includes('change_customer')) {
          this.store.dispatch(UserActions.loginRedirect());
          return false;
        }
        return true;
      }),
      take(1)
    );
  }
}
